import React from "react";
import { languages } from "../../../constants/languages";
import { withTheme } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@mdi/react";
import { mdiPodium } from "@mdi/js";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import NumRowsPerFontSize from "../../../constants/NumRowsPerFontSize";

class RankingContainer extends React.Component {
  state = {
    anchorEl: null,
  };

  openMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleSubmit = (e, divisionId, rankingNum) => {
    e.preventDefault();
    let numInDia = null;
    // if (this.props.structureElement) {
    //   numInDia = this.props.structureElement.numInDia;
    // }

    if (numInDia === null) {
      numInDia = 0;
      if (this.props.structureElements.length > 0) {
        let lastElement =
          this.props.structureElements[
            this.props.structureElements.length - 1
          ] || {};
        numInDia =
          lastElement[
            lastElement.numInDiaLocal !== undefined
              ? "numInDiaLocal"
              : "numInDia"
          ] + 1;
      }
    }

    let toUpdate = {};
    toUpdate["diaRankingIndex" + divisionId + rankingNum.toString()] = numInDia;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(this.props.dia.id)
      .update(toUpdate);
  };

  render() {
    let rankingsPerDivision = {};
    let rankingMenuItems = [];
    let fontSize = this.props.fontSize;
    let maxTeams = NumRowsPerFontSize[Number(fontSize)];
    this.props.divisions.forEach((division) => {
      let numRankings = Math.ceil(
        (this.props.ranking[division.id] || []).length / maxTeams
      );
      if (rankingsPerDivision[division.id] === undefined) {
        rankingsPerDivision[division.id] = [];
      }
      for (let i = 0; i < numRankings; i++) {
        rankingsPerDivision[division.id].push(i);
      }
      let menuItems = rankingsPerDivision[division.id].map((i) => {
        return (
          <MenuItem
            style={{
              height: 30,
              padding: "0 40px 0 10px",
            }}
            key={division.id + i}
            onClick={(e) => {
              this.closeMenu();
              this.handleSubmit(e, division.id, i);
            }}
            disabled={
              this.props.dia["diaRankingIndex" + division.id + i] !== null &&
              this.props.dia["diaRankingIndex" + division.id + i] !== undefined
            }
          >
            {languages.results.ranking +
              (this.props.divisions.length > 1
                ? " (" + division.name + ") "
                : "") +
              (numRankings > 1
                ? " (" + (i + 1).toString() + "/" + numRankings.toString() + ")"
                : "")}
          </MenuItem>
        );
      });
      rankingMenuItems = rankingMenuItems.concat(menuItems);
    });
    return (
      <div style={{ display: "inline-block" }}>
        <Tooltip title={languages.results.ranking}>
          <IconButton onClick={this.openMenu} size="small">
            <Icon
              path={mdiPodium}
              color="rgba(0, 0, 0, 0.54)"
              style={{ height: 20, width: 20 }}
            />
          </IconButton>
        </Tooltip>
        <Menu
          id="lock-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.closeMenu}
          PaperProps={{
            style: {
              maxHeight: 30 * 6,
              minWidth: 180,
            },
          }}
        >
          {rankingMenuItems}
        </Menu>
      </div>
    );
  }
}

export default withTheme(RankingContainer);
